import { render, staticRenderFns } from "./ReviewPage.router.vue?vue&type=template&id=22dc042a&"
import script from "./ReviewPage.router.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.router.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports